<template>
  <PageLayout>
    <template v-slot:header>
      <div class="ui padded grid">
        <div class="row">
          <div class="sixteen wide column">
            <Breadcrumb>
              <div class="active section">
                <div class="neutral">Pesquisa de contratos</div>
              </div>
            </Breadcrumb>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:main>
      <div class="ui padded grid">
        <div class="row">
          <div class="sixteen wide column">
            <form @submit.prevent="search()" class="ui small form search-form">
              <div class="fields">
                <div class="six wide field">
                  <label for="contract-search-description"
                    >CPF, Titular ou Dependente</label
                  >
                  <input
                    type="text"
                    name="contract-search-description"
                    v-model="searchForm.description"
                    autofocus
                  />
                </div>
                <div class="end field">
                  <input
                    type="submit"
                    name="commit"
                    value="Filtrar"
                    class="ui button"
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="row">
          <div class="sixteen wide column">
            <Grid
              ref="grid"
              :columns="gridColumns"
              resource="contracts"
              :showActions="false"
              @refresh="search()"
              @page="n => search(n)"
            />
          </div>
        </div>
      </div>
    </template>
  </PageLayout>
</template>

<script>
import Api from '@/resources/Api';
import Breadcrumb from '@/components/breadcrumb';
import PageLayout from '@/layouts/page_layout';
import Grid from '@/components/grid';

export default {
  name: 'services',
  components: { Grid, Breadcrumb, PageLayout },

  data() {
    return {
      anyResult: false,
      searchForm: {
        description: null
      },
      query: {},
      gridColumns: [
        {
          kind: 'label',
          field: 'state',
          description: 'Situação',
          map: {
            pending: {
              color: 'orange',
              description: 'Pendente'
            },
            enable: {
              color: 'green',
              description: 'Ativo'
            },
            canceled: {
              color: 'red',
              description: 'Cancelado'
            },
            overdue: {
              color: 'orange',
              description: 'Inadimplente'
            }
          }
        },
        { description: 'Contrato', field: 'id', align: 'center' },
        { description: 'Titular', field: 'owner_name' },
        { description: 'CPF / CNPJ', field: 'owner_doc' },
        {
          description: '',
          to: '/p/contracts/:id',
          title: 'Visualizar',
          kind: 'link'
        }
      ]
    };
  },

  mounted() {
    // this.search();
  },

  methods: {
    _setResults(contracts, pagination) {
      this.$refs.grid.setItems(contracts);
      this.$refs.grid.setPaginate(pagination);
    },

    search(page = 1) {
      const query = {
        q: {
          associates_owner_cpf_or_associates_owner_name_or_owner_cpf_or_owner_name_or_users_name_cont: this.searchForm
            .description,
          state_not_eq: 'canceled',
          s: ['created_at desc']
        },
        page: page
      };

      this.$refs.grid.toggleLoading();
      return Api.contracts
        .search(query)
        .then(async response => {
          this.$refs.grid.setItems(response.data.contracts);
          this.$refs.grid.setPaginate(response.data.pagination);
        })
        .catch(error => {
          this.$toast.show('Erro ao buscar dados', 'error');
          throw error;
        })
        .finally(() => {
          this.$refs.grid.toggleLoading();
        });
    }
  }
};
</script>
